import * as React from 'react';
import { cn } from '@/shared/lib/cn';
import styles from './UnreadBadge.module.css';

export interface UnreadBadgeProps extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'children'> {
  count: number;
  muted?: boolean;
}

/**
 * Сколько нового ждёт человека: синяя пилюля с числом.
 *
 * Жила пятью копиями css (сайдбар, колокольчик, каналы мессенджера, две кнопки
 * «вниз») с тремя разными ростами, а вкладка «Заметки» говорила то же серым
 * счётчиком и отдельной точкой — и читалась чужой (владелец, 29.10.2026).
 * Положение задаёт место вызова через `className`, вид — только здесь.
 *
 * Ноль не рисуется: «нового нет» — это отсутствие знака, а не «0».
 *
 * @use число непрочитанного или ждущего решения: пункт навигации, колокольчик, канал, кнопка «вниз», вкладка (через `TabsCount unread`). Количество элементов раздела — это TabsCount, метка-признак — Badge.
 */
export const UnreadBadge = React.forwardRef<HTMLSpanElement, UnreadBadgeProps>(function UnreadBadge(
  { count, muted, className, ...rest },
  ref,
) {
  if (count <= 0) return null;
  return (
    <span
      ref={ref}
      aria-label={`Непрочитанных: ${count}`}
      {...rest}
      className={cn(styles.badge, muted && styles.muted, className)}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
});
